<template>
  <div class="overlay-buttons" v-if="overlays.length > 0">
    <button
      :class="{ 'overlay-buttons__button': true, 'overlay-buttons__button--selected': isCurrent(null) }"
      @click="currentOverlay = null"
      aria-label="No overlay"
    >
      X
    </button>
    <button
      v-for="(overlay, index) in overlays"
      :key="overlay.name"
      :class="{
        'overlay-buttons__button': true,
        'overlay-buttons__button--selected': isCurrent(overlay),
        'overlay-buttons__button--loading': isCurrent(overlay) && loading,
      }"
      type="button"
      @click="currentOverlay = overlay"
      :aria-label="`Overlay ${(index + 1)}`"
    >
      {{ index + 1 }}
    </button>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

defineProps({
  overlays: { type: Array, default: () => [] },
});
const emit = defineEmits(['load', 'change']);

const currentOverlay = ref(null);
const loading = ref(false);

watch(currentOverlay, async () => {
  emit('change', currentOverlay.value);
  if (currentOverlay.value) {
    loading.value = true;
    let response = await fetch(`${currentOverlay.value.base_uri}/metadata.json`);
    let metadata = await response.json();
    emit('load', { overlay: currentOverlay.value, metadata });
    loading.value = false;
  } else {
    emit('load', { overlay: null });
  }
});

function isCurrent(overlay) {
  if (!currentOverlay.value) return !overlay;

  return currentOverlay.value.identifier === overlay?.identifier;
}
</script>
